export default () => ({
  _active: null,
  active: null,
  lockNav: false,
  lockTime: 500, // ms
  over: null,

  init() {
    // _active acts as a simple proxy to allow using visibility: hidden
    // on submenus - it's removed and css transitions trigger on the
    // next frame
    this.$watch("_active", (newValue, oldValue) => {
      if (newValue) {
        // submenu wants to open
        const submenu = this.$el.querySelector(`#submenu-${newValue}`);

        if (submenu) {
          submenu.style.visibility = "initial";
          this.$nextTick(() => {
            this.active = newValue;
          });
        }
      } else {
        // submenu is closing
        const submenu = this.$el.querySelector(`#submenu-${oldValue}`);

        if (submenu) {
          // don't allow timeouts to stack and cause weirdness
          this.lockNav = true;
          this.active = newValue;

          setTimeout(() => {
            submenu.style.visibility = "hidden";
            this.lockNav = false;
          }, this.lockTime);
        }
      }
    });
  },

  setActive(id) {
    if (this.lockNav) return;

    if (id === this.active) {
      this._active = null;
      return;
    }

    this._active = id;
  },

  setOver(id) {
    this.over = id;
  },

  closeAll() {
    this._active = null;
  },
});
